/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { SET_BOOTH_STATUS } from '../features/queues';
import { getCBXSocket } from '../web-socket/client';

// eslint-disable-next-line require-yield
function* setBoothStatus(action: any) {
  const socketClient = getCBXSocket();
  if (socketClient) {
    socketClient.send({
      cmd: 'booth/booth-status',
      status: action.payload
    });
  }
}

export function* setBoothStatusSaga() {
  yield takeLatest(SET_BOOTH_STATUS, setBoothStatus);
}
